import {
  CLOSE_CONFIRMATION_MODAL,
  SET_CONFIRMATION_MODAL,
  SET_CONFIRMATION_MODAL_FORM,
  SET_CONFIRMATION_MODAL_FORM_ERROR_MESSAGE,
} from '../../ActionTypes'

export const setConfirmationModal = (modalProps) => ({
  type: SET_CONFIRMATION_MODAL,
  modalProps,
})

export const closeConfirmationModal = () => ({
  type: CLOSE_CONFIRMATION_MODAL,
})
export const setConfirmationModalForm = (form) => ({
  type: SET_CONFIRMATION_MODAL_FORM,
  form,
})
export const setConfirmationModalFormErrorMessage = (formErrors) => ({
  type: SET_CONFIRMATION_MODAL_FORM_ERROR_MESSAGE,
  formErrors,
})
